function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 8a2 2 0 00-2 2H6a4 4 0 014-4v2z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-6a6 6 0 100 12 6 6 0 000-12z",
  fill: "#4038FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.293 17.707l4.303 4.303 1.414-1.414-4.303-4.303-1.414 1.414z",
  fill: "#4038FF"
});

var SvgValidateAndStake = function SvgValidateAndStake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDhDOC44OTU0MyA4IDggOC44OTU0MyA4IDEwSDZDNiA3Ljc5MDg2IDcuNzkwODYgNiAxMCA2VjhaIiBmaWxsPSIjNDAzOEZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAxMEMyIDUuNTgxNzIgNS41ODE3MiAyIDEwIDJDMTQuNDE4MyAyIDE4IDUuNTgxNzIgMTggMTBDMTggMTQuNDE4MyAxNC40MTgzIDE4IDEwIDE4QzUuNTgxNzIgMTggMiAxNC40MTgzIDIgMTBaTTEwIDRDNi42ODYyOSA0IDQgNi42ODYyOSA0IDEwQzQgMTMuMzEzNyA2LjY4NjI5IDE2IDEwIDE2QzEzLjMxMzcgMTYgMTYgMTMuMzEzNyAxNiAxMEMxNiA2LjY4NjI5IDEzLjMxMzcgNCAxMCA0WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNMTYuMjkzIDE3LjcwNzJMMjAuNTk1NyAyMi4wMDk5TDIyLjAwOTkgMjAuNTk1N0wxNy43MDcyIDE2LjI5M0wxNi4yOTMgMTcuNzA3MloiIGZpbGw9IiM0MDM4RkYiLz4KPC9zdmc+Cg==";
export { SvgValidateAndStake as ReactComponent };